<template>
<div id="preview" preview-modal=""
  :class="['modal', dataType, myStyle]" ref="modal">
  <button class="btn-floating transparent waves-effect z-depth-0 right-top modal-close"><i class="material-icons white-text">close</i></button>
  <div class="modal-content">
    <div class="image-header" v-if="content" :class="content.acf.link.type === 'image' ? 'image-link' : ''">
      <image-component v-if="dataType === 'posts'"  data-type="special_bg" size="full" 
      :data-id="content.featured_media" :show-caption="false" />
      <image-component v-else data-type="special_bg" size="full" :show-caption="false"
      :data-id="content.acf.image" />
      <div class="pop-over-styling" v-if="myStyle === 'pop_over'">
          <div class="pop-over-title">
            <a  
              :style="`color: ${content.acf.content_style.title}`"
              v-if="content && content.acf.link.url" :href="content.acf.link.url" class="pop-over-title" 
              v-html="content.title.rendered"></a>
          </div>
          <div class="pop-over-description"
          :style="`color: ${content.acf.content_style.content}`">
            <span v-html="content.acf.message"></span>
          </div>
          <div class="pop-over-action">
            <a class="btn waves-effect"
            :style="`color: ${content.acf.content_style.button.text}; background: ${content.acf.content_style.button.background}`"
            :href="content.acf.link.url"  v-text="content.acf.button_label"></a>
          </div>
      </div>
      <div class="modal-header" v-else>
        <div class="header-title" v-if="content">
        <a  v-if="content && content.acf.link.url" :href="content.acf.link.url" class="white-text"  v-html="content.title.rendered"></a>
        <span v-else v-html="content.title.rendered" class="white-text"></span>
        </div>
        <div class="description" v-if="content" v-html="content.acf.message"></div>
        <a :href="content.acf.link.url" v-if="content && content.acf.link.type === 'button'" class="btn blue moving accent-4 waves-effect white-text">View </a>
      </div>

    </div>
    <div class="content" v-if="content && dataType !== 'notifications'" v-html="content.content.rendered"></div>
 </div>
  </div>
</template>
<script>
import imageComponent from '@/components/imageComponent'
import contentService from '@/services/contentService'
import M from 'materialize-css'
export default {
  name: 'coolPreview',
  props: {
    dataType: {
      type: [String, Boolean],
      default: 'posts' // options image-content && image-text
    },
    dataId: {
      type: [Number, String, Boolean]
    }
  },
  components: {
    imageComponent
  },
  data () {
    let vm = this
    return {
      content: false,
      modal: {
        instance: null,
        options: {
          opacity: 0.3,
          onOpenStart: () => {
          },
          onCloseEnd: () =>  {
            vm.$emit('update', false)
          }
        }
      }
    }
  },
  mounted () {
    contentService.getByTypeAndId(this.dataType, this.dataId)
    .then(res => {
      this.content = res.data
      this.modal.options.opacity = this.overlay
      this.modal.options.startingTop = '100%'
      this.modal.options.endingTop = '50%'
      if (this.overlay !== 'pop_over') {
        this.modal.options.preventScrolling = false
        document.querySelector('body').classList.add('remove_overlay')
      }
      this.$_initModal()  
    })
  },
  computed: {
    state: {
      get () {
        return this.modal.instance !== null ? this.modal.instance.isOpen : false
      }
    },
    overlay:{
      get () {
        return this.myStyle === 'pop_over' ? 0.3 : 0
      }
    },
    myStyle: {
      get () {
        return this.content && this.content.acf.style ? this.content.acf.style : 'pop_over'
      }
    }
  },
  methods: {
    $_ifImageLink (link) {
      window.location.href = link.url
    },
    $_initModal () {
      this.modal.instance = M.Modal.init(this.$refs.modal, this.modal.options)
      this.$_openModal()
    },
    $_openModal() {
      if (this.modal.instance) {
        setTimeout(() => {
          this.modal.instance.open()
        }, 100);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
 .image-header {
  height: 350px;
  width:100%;
  position: relative;  
}
 picture{
  height: 350px;
  width: 100%;
  display: inherit;
}
.modal {
  height: auto;
  max-width: 690px;
  max-height: 95%;
  border-radius: 8px;
}
.modal.notifications {
  /* top:50% !important; */
  transform:scaleX(1) scaleY(1) translateY(-50%)!important;
}
.modal.notifications.side_pop_up {
  right: 24px !important;
  left: auto;
  bottom: 56px;
  top: auto !important;
  transform: scaleX(1) scaleY(1) translateY(0%) !important;
  max-width: 350px;
  width: 100%;
  border-radius: 6px;
}
 .modal-header {
    position: absolute;
    bottom: 0;
    left: 0;
    height: auto;
    right: 0;
    background: linear-gradient(0deg, rgba(0,0,0,1), rgba(0, 0, 0, .17));
    z-index: 9;
    padding: 16px 16px;
    color: #fff;
  }
 .modal-header .header-title {
  font-size: 24px;
  line-height: 1.2;
}
 .modal-header .description  p{
  margin: 2px 0px;
}
 .modal-content {
    padding: 0px !important;
  }
 .content {
  padding: 12px 20px;
}
 h1,  h2,  h3,  h4,  h5 {
  font-size: 28.5px
}
 .sd-content {
  display: none;
}
 .right-top {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 99;
  background: rgba(0,0,0,0.2) !important;
}
 a.moving {
  margin-top: 12px;
 /*  width: 100%; */
}
 .image-link {
  cursor: pointer;
}
.remove_overlay .modal-overlay {
  z-index: -1 !important;
  display: none !important;
}
.pop_over {
  .image-header {
    &::before {
      content: ' ';
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      z-index: 1;
      bottom: 0;
      background: rgba(0,0,0,0.3);
    }
  }

  .pop-over-styling {
      position: absolute;
      left: 33px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 99;
      .pop-over-title {
        font-size: 36px;
        line-height: 42px;
        margin-bottom: 8px;
      }
    }
    .pop-over-action {
      .btn {
      height: 44px;
      line-height: 44px;
      }
    }
}

</style>
<style lang="scss">
.description {
  p {
    margin: 4px 0px 12px;
  }
}
.pop-over-description {
    margin-top: 6px;
    margin-bottom: 12px;
  p {
    font-size: 17px;
    margin: 4px 0px 12px;
    line-height: 1.35;
  }
}
</style>